export const queryKeys = {
  all: ['capacity-planner'] as const,
  // Phase 1
  settings: (clientId: string) =>
    ['capacity-planner', 'settings', clientId] as const,
  capacity: (
    clientId: string,
    startDate: string,
    endDate: string,
    options?: { team?: string; search?: string; weekLabel?: string; periodStart?: string; page?: number; pageSize?: number }
  ) =>
    ['capacity-planner', 'capacity', clientId, startDate, endDate, options?.team ?? '', options?.search ?? '', options?.weekLabel ?? '', options?.periodStart ?? '', options?.page ?? 1, options?.pageSize ?? 25] as const,
  workflow: (clientId: string, options?: { staffId?: string; state?: string; search?: string; page?: number; pageSize?: number }) =>
    ['capacity-planner', 'workflow', clientId, options?.staffId ?? '', options?.state ?? '', options?.search ?? '', options?.page ?? 1, options?.pageSize ?? 25] as const,
  allocationCandidates: (clientId: string, options?: { allocationStatus?: string; state?: string; search?: string; page?: number; pageSize?: number }) =>
    ['capacity-planner', 'allocation-candidates', clientId, options?.allocationStatus ?? '', options?.state ?? '', options?.search ?? '', options?.page ?? 1, options?.pageSize ?? 25] as const,
  sourceAllocationStaff: (clientId: string, jobId: string) =>
    ['capacity-planner', 'source-allocation-staff', clientId, jobId] as const,
  allocations: (
    clientId: string,
    weekStart: string,
    weekEnd: string,
    options?: { search?: string; staffId?: string; page?: number; pageSize?: number }
  ) =>
    ['capacity-planner', 'allocations', clientId, weekStart, weekEnd, options?.search ?? '', options?.staffId ?? '', options?.page ?? 1, options?.pageSize ?? 25] as const,
  staffAvailability: (
    clientId: string,
    weekStart: string,
    weekEnd: string,
    options?: { search?: string; staffId?: string; page?: number; pageSize?: number }
  ) =>
    ['capacity-planner', 'staff-availability', clientId, weekStart, weekEnd, options?.search ?? '', options?.staffId ?? '', options?.page ?? 1, options?.pageSize ?? 25] as const,
  allocationRecommendations: (clientId: string, jobIds: string[], weekStart: string, weekCount: number) =>
    ['capacity-planner', 'allocation-recommendations', clientId, jobIds.slice().sort().join(','), weekStart, weekCount] as const,
}
